import { render, staticRenderFns } from "./ExpensesDirectCosts.vue?vue&type=template&id=150ce73c"
import script from "./ExpensesDirectCosts.vue?vue&type=script&lang=js"
export * from "./ExpensesDirectCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports